const $$splitComponentImporter = () => import('/app/src/routes/dashboard/therapist/blog/new.tsr-split.component.tsx');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/dashboard/therapist/blog/new")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});